import React from 'react';

interface CloseButtonProps {
    handleClick: () => void;
}
export function CloseButton({ handleClick }: CloseButtonProps) {
    return (
        <button
            type="button"
            className="modal-close-button"
            aria-label="Close"
            onClick={handleClick}
        >
            <span aria-hidden="true">&times;</span>
            <span className="sr-only">Close</span>
        </button>
    );
}
